<ca-modal-container
    [modalTitle]="'SUPPORTED_FORMATS_DIALOG.TITLE' | translate"
    (dismiss)="dismiss()"
    class="d-flex flex-column pb-0 px-0 rounded-0"
    [hasFullwidthButton]="true"
>
    <div class="mb-4 p-4">
        <p>{{ 'SUPPORTED_FORMATS_DIALOG.DESCRIPTION' | translate }}</p>
        <div class="mb-4">
            <p class="fw-bold mb-1">{{ 'SUPPORTED_FORMATS_DIALOG.RECOMMENDED_FILE_TYPES' | translate }}</p>
            <span class="supported-files-list">{{ recommendedFileTypes }}</span>
        </div>
        <div class="mb-4">
            <p class="fw-bold mb-1">{{ 'SUPPORTED_FORMATS_DIALOG.OTHER_FILE_TYPES' | translate }}</p>
            <span class="supported-files-list">{{ otherFileTypes }}</span>
        </div>
        <div>
            <div class="mb-2">
                <p class="mb-0">{{ 'SUPPORTED_FORMATS_DIALOG.POTENTIALLY_VALID_FILE_TYPES' | translate }}</p>
                <a class="contact-us link-inline" (click)="openContactUs()">{{ 'SUPPORTED_FORMATS_DIALOG.CONTACT_US' | translate }}</a>
                <span>{{ 'SUPPORTED_FORMATS_DIALOG.CONTACT_US_SUPPORT' | translate }}</span>
            </div>
            <span class="supported-files-list">{{ potentiallyUploadableFileTypes }}</span>
        </div>
    </div>
    <div class="modal-buttons w-100">
        <button type="button" class="btn btn-primary w-100" caAutoFocus data-uit="supported-formats-dialog-btn" (click)="dismiss()">
            {{ 'SUPPORTED_FORMATS_DIALOG.BUTTON' | translate }}
        </button>
    </div>
</ca-modal-container>
